import { motion } from 'framer-motion';
import { useReducedMotion } from '../hooks/useReducedMotion';

const variants = {
    initial: { opacity: 0, y: 12 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -8 },
};

const reducedVariants = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
};

export const PageTransition = ({ children, className = '' }) => {
    const prefersReduced = useReducedMotion();
    const activeVariants = prefersReduced ? reducedVariants : variants;

    return (
        <motion.div
            variants={activeVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: prefersReduced ? 0 : 0.25, ease: [0.16, 1, 0.3, 1] }}
            className={className}
        >
            {children}
        </motion.div>
    );
};
